import clsx from 'clsx';
import { Spin } from 'antd';

import { useCategory } from '../../../../../store/category';
import CategoryButton from '../CategoryButton';
import { useCategoryContext } from '../CategoryProvider';

import styles from './index.module.scss';

interface CategoryListProps {
  className?: string;
}

const CategoryList = ({ className }: CategoryListProps) => {
  const { categoryId, setCategoryId } = useCategoryContext();
  const { listAll } = useCategory();

  if (listAll.loading) {
    return (
      <div className={styles.loading}>
        <Spin />
      </div>
    );
  }

  return (
    <div className={clsx(styles.wrapper, className)}>
      {listAll.response?.data.map((category) => (
        <CategoryButton
          key={category.id}
          category={category}
          isActive={categoryId === category.id}
          onClick={() => setCategoryId(category.id)}
          className={styles.button}
        />
      ))}
    </div>
  );
};

export default CategoryList;
